import green from '@material-ui/core/colors/green';

export const styles = theme => ({
  snackbarRoot: {
    [theme.breakpoints.down('xs')]: {
      left: theme.spacing(1),
      right: theme.spacing(1),
      bottom: '72px !important',
      alignItems: 'stretch',
    },
  },
  default: {
    '&&': {
      color: '#fff',
      backgroundColor: 'rgba(49, 49, 49, 0.71)',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
      boxSizing: 'border-box',
      borderRadius: 8,
    },
  },
  messageContent:{
    padding: 0,
    width: '100%',
    minWidth: 0,
  },
  container: {
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    minWidth: 0,
  },
  containerText:{
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    minWidth: 0,
    marginRight: '10px',
    overflowWrap: 'anywhere',
  },
  success: {
    '&&': {
      color: '#fff',
      backgroundColor: green[600],
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
      boxSizing: 'border-box',
      borderRadius: 8,
    },
  },
  error: {
    '&&': {
      color: '#fff',
      backgroundColor: '#E15554',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
      boxSizing: 'border-box',
      borderRadius: 8,
    },
  },
  info: {
    '&&': {
      color: '#fff',
      backgroundColor: theme.palette.primary.dark,
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
      boxSizing: 'border-box',
      borderRadius: 8,
    },
  },
  warning: {
    '&&': {
      color: '#fff',
      backgroundColor: '#F79824',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
      boxSizing: 'border-box',
      borderRadius: 8,
    },
  },
});
